/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WebColorScheme = 'Auto' | 'Light' | 'Dark';

export const WebColorScheme = {
    Auto: 'Auto' as WebColorScheme,
    Light: 'Light' as WebColorScheme,
    Dark: 'Dark' as WebColorScheme
};

